"use client";

import { useState, type FormEvent } from "react";
import { IconMail } from "./icons";

export default function Contact() {
  const [submitted, setSubmitted] = useState(false);

  function handleSubmit(e: FormEvent<HTMLFormElement>) {
    e.preventDefault();
    // UI-only form: wire this up to your backend, form provider,
    // or CRM of choice (e.g. an API route, HubSpot, Formspree).
    setSubmitted(true);
  }

  return (
    <section id="contact" className="bg-white py-24 dark:bg-ink-950 sm:py-28">
      <div className="section grid grid-cols-1 gap-14 lg:grid-cols-[0.85fr_1.15fr] lg:gap-16">
        <div>
          <span className="eyebrow">Contact</span>
          <h2 className="mt-4 text-3xl font-medium tracking-tight text-ink-900 dark:text-white sm:text-4xl">
            Tell us about your project
          </h2>
          <p className="mt-4 max-w-md text-lg leading-relaxed text-ink-700 dark:text-white/70">
            Share a few details and a member of our team will get back to
            you within one business day.
          </p>

          <div className="mt-10 space-y-6 border-t border-ink-900/[0.08] pt-8 dark:border-white/10">
            <div>
              <p className="text-sm font-semibold uppercase tracking-wide text-ink-500 dark:text-white/40">
                Company
              </p>
              <p className="mt-1 text-lg font-medium text-ink-900 dark:text-white">
                TalkSoon Labs
              </p>
            </div>
            <div>
              <p className="text-sm font-semibold uppercase tracking-wide text-ink-500 dark:text-white/40">
                Email
              </p>
              <a
                href="mailto:hello@talkyousoon.com"
                className="mt-1 inline-flex items-center gap-2 text-lg font-medium text-ink-900 transition-colors hover:text-brand-700 dark:text-white dark:hover:text-brand-300"
              >
                <IconMail className="h-4 w-4 text-brand-600 dark:text-brand-300" />
                hello@talkyousoon.com
              </a>
            </div>
            <div>
              <p className="text-sm font-semibold uppercase tracking-wide text-ink-500 dark:text-white/40">
                Response time
              </p>
              <p className="mt-1 text-lg font-medium text-ink-900 dark:text-white">
                Within 1 business day
              </p>
            </div>
          </div>
        </div>

        <div className="card p-7 sm:p-9">
          {submitted ? (
            <div
              role="status"
              className="flex flex-col items-start gap-3 py-10"
            >
              <div className="flex h-11 w-11 items-center justify-center rounded-full bg-brand-50 text-brand-700 dark:bg-brand-500/10 dark:text-brand-300">
                <IconMail className="h-5 w-5" />
              </div>
              <h3 className="text-xl font-semibold text-ink-900 dark:text-white">
                Thanks — message received.
              </h3>
              <p className="max-w-sm text-[15px] leading-relaxed text-ink-600 dark:text-white/60">
                We&apos;ll review the details and follow up at
                hello@talkyousoon.com within one business day.
              </p>
            </div>
          ) : (
            <form onSubmit={handleSubmit} noValidate>
              <div className="grid grid-cols-1 gap-5 sm:grid-cols-2">
                <div>
                  <label
                    htmlFor="name"
                    className="text-sm font-medium text-ink-800 dark:text-white/80"
                  >
                    Name
                  </label>
                  <input
                    id="name"
                    name="name"
                    type="text"
                    autoComplete="name"
                    required
                    placeholder="Jordan Lee"
                    className="input"
                  />
                </div>
                <div>
                  <label
                    htmlFor="email"
                    className="text-sm font-medium text-ink-800 dark:text-white/80"
                  >
                    Email
                  </label>
                  <input
                    id="email"
                    name="email"
                    type="email"
                    autoComplete="email"
                    required
                    placeholder="jordan@company.com"
                    className="input"
                  />
                </div>
              </div>

              <div className="mt-5">
                <label
                  htmlFor="company"
                  className="text-sm font-medium text-ink-800 dark:text-white/80"
                >
                  Company
                </label>
                <input
                  id="company"
                  name="company"
                  type="text"
                  autoComplete="organization"
                  placeholder="Company name"
                  className="input"
                />
              </div>

              <div className="mt-5">
                <label
                  htmlFor="message"
                  className="text-sm font-medium text-ink-800 dark:text-white/80"
                >
                  Message
                </label>
                <textarea
                  id="message"
                  name="message"
                  rows={5}
                  required
                  placeholder="Tell us a bit about your project, timeline, and goals."
                  className="input resize-none"
                />
              </div>

              <button type="submit" className="btn-primary mt-6 w-full sm:w-auto">
                Submit
              </button>

              <p className="mt-3 text-xs leading-relaxed text-ink-500 dark:text-white/40">
                This form is UI-only. Connect it to an API route or your
                preferred form backend to receive submissions.
              </p>
            </form>
          )}
        </div>
      </div>
    </section>
  );
}
